import React, { useEffect, useState } from "react";
import axios from "axios";
import SingleItem from "./SingleItem";
import CustomPagination from "../../CustomPagination/CustomPagination";
import { toast } from "react-toastify";

const Orders = () => {

    const [loading, setLoading] = useState(true);
    const [paginateData, setPaginateData] = useState({});
    const [data, setData] = useState([]);
    const [result, setResult] = useState({});

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setLoading(true);

                const response = await axios.get(
                    `https://api.velormall.com/api/admin/order/user/assign/all/view`
                );

                setData(response?.data?.data || []);
                setPaginateData(response?.data || {});
            } catch (error) {
                console.error("Failed to fetch orders:", error);
                setData([]);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();

    }, [result]);

    const handlePage = async (event) => {
        try {
            const pageNumber = event?.selected + 1;

            const response = await axios.get(
                `https://api.velormall.com/api/admin/order/user/assign/all/view?page=${pageNumber}`
            );

            setData(response?.data?.data || []);
            setPaginateData(response?.data || {});
        } catch (error) {
            console.error("Pagination error:", error);
        }
    };



    const handleDelete = (id) => {
        try {
            fetch(`https://api.velormall.com/api/admin/order/user/assign/delete/${id}`, {
                method: "DELETE",
                headers: {
                    "content-type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setResult(data);
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                })
                .catch((error) => console.log(error));
        } catch (error) {
            // console.log(error)
        }
    };


    return (
        <div className="mt-30">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex mb-2 flex-wrap gap-3 justify-content-between align-items-center">
                        <h6 className="page-title">Order Lists</h6>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card b-radius--10">
                                <div className="card-body p-0">
                                    <div className="table-responsive--md table-responsive">
                                        <table className="table table--light style-two mb-0">
                                            <thead>
                                                <tr>
                                                    <th>S.N</th>
                                                    <th>Type</th>
                                                    <th>Order #</th>
                                                    <th>Username</th>
                                                    <th>Product</th>
                                                    <th>Amount</th>
                                                    <th>Profit %</th>
                                                    <th>Profit Amount</th>
                                                    <th>Total With Profit</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td
                                                            colSpan="9"
                                                            className="text-center text-muted"
                                                        >
                                                            Loading orders...
                                                        </td>
                                                    </tr>
                                                ) : data.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <SingleItem
                                                            key={item._id}
                                                            data={item}
                                                            index={index}
                                                            handleDelete={handleDelete}
                                                        />
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan="9"
                                                            className="text-center text-muted"
                                                        >
                                                            Data not found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* paginateLinks */}
                                <CustomPagination
                                    data={paginateData}
                                    handlePage={handlePage}
                                ></CustomPagination>
                                {/* paginateLinks */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orders;